export const projects = [
  {
    title: "CCRental Project",
    subtitle: "MERN Stack",
    description:
      "A fully-functional web application that helps Singaporeans to compare car renting prices among the established car renting services in Singapore. ",
    image: "../public/CC_rental_Home.png",
    link: "https://github.com/keenlim/SC2006-Project",
  },
  {
    title: "MOBILMA Application",
    subtitle: "Java",
    description:
      "A non-GUI application that helps to computerise the processes of making online booking and purchase of movie tickets, listing of movies and sale reporting. This was designed for both movie goers and cinema staff.",
    image: "./MOBILMA.gif",
    link: "https://github.com/keenlim/SC2002-Project",
  },
  {
    title: "Classification and Detection of Disaster Tweets",
    subtitle: "Python",
    description:
      "Identify tweets that are deemed as a Disaster Tweet through the use of Data extraction from Kaggle and Machine Learning. To achieve the goals, we have found suitable dataset, clean the data, find suitable model for training as well as implementing the idea.",
    image: "./Classification.gif",
    link: "https://github.com/keenlim/mini-project",
  },
  {
    title: "CSIT Software Engineering Mini Challenge",
    subtitle: "Node JS, Javascript",
    description:
      "Uses Javascript as well as performed unit testing to complete the application. The main aim of the project was to get a list of return flights at the cheapest price, given the query parameters from a populated list of information in the database. As well as getting a list of hotels providing the cheapest price.",
    image: "./CSIT SE Digital Badge.png",
    link: "https://github.com/keenlim/CSIT-Software-Engineering-Mini-Challenge-2023",
  },
];

export const skills = [
  "JavaScript",
  "React JS",
  "Node JS",
  "Python",
  "Java",
  "C",
];
